import { TicketServiceAdapter as c } from "../../../ticket/ticketService/ticketService.adapter.js";
import { TicketSummaryAdapter as a } from "../../../ticket/ticketSummary/ticketSummary.adapter.js";
import { OrderRecordModel as r } from "./order.record.model.js";
import { Adapter as n, getAdapter as i } from "../../../../adapter.js";
class p extends n {
  adapt(t) {
    const { order: e } = t;
    return new r({
      channel: e.channel,
      created: e.created,
      id: e.id,
      location: e.location,
      status: e.status,
      ticketDatetime: e.ticket_datetime,
      ticketId: e.ticket_id,
      ticketNumber: e.ticket_number,
      ticketService: e.ticket_service ? i(c).adapt(e.ticket_service) : void 0,
      ticketSummary: i(a).adapt(e.ticket_summary),
      timestamp: new Date(e.timestamp * 1e3),
      scope: {
        location: {
          id: e.scope.location.id,
          name: e.scope.location.name
        }
      }
    });
  }
  serialize(t) {
    return {
      order: {
        channel: t.channel,
        created: t.created,
        id: t.id,
        location: t.location,
        status: t.status,
        ticket_datetime: t.ticketDatetime,
        ticket_id: t.ticketId,
        ticket_number: t.ticketNumber,
        ticket_service: t.ticketService ? {
          now: t.ticketService.now,
          ready_at: t.ticketService.readyAt,
          service_type: t.ticketService.serviceType,
          table_id: t.ticketService.tableId
        } : void 0,
        ticket_summary: {
          currency: t.ticketSummary.currency,
          discount_amount: t.ticketSummary.discountAmount,
          payment_fee: t.ticketSummary.paymentFee,
          raw_service_fee: t.ticketSummary.rawServiceFee,
          service_fee: t.ticketSummary.serviceFee,
          subtotal: t.ticketSummary.subtotal,
          taxes: t.ticketSummary.taxes,
          tip: t.ticketSummary.tip,
          total: t.ticketSummary.total
        },
        timestamp: t.timestamp,
        scope: {
          location: {
            id: t.scope.location.id,
            name: t.scope.location.name
          }
        }
      }
    };
  }
}
export {
  p as OrderRecordAdapter
};
//# sourceMappingURL=order.record.adapter.js.map
